function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#007F4E",
  width: 20,
  height: 20,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M10.5 13.646L14.517 16l-1.063-4.44L17 8.575l-4.674-.39L10.5 4 8.674 8.185 4 8.575l3.546 2.985L6.483 16z"
}));

function SvgTrustpilotStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3QgZmlsbD0iIzAwN0Y0RSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgLz4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEwLjUgMTMuNjQ2TDE0LjUxNyAxNmwtMS4wNjMtNC40NEwxNyA4LjU3NWwtNC42NzQtLjM5TDEwLjUgNCA4LjY3NCA4LjE4NSA0IDguNTc1bDMuNTQ2IDIuOTg1TDYuNDgzIDE2eiIgLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgTrustpilotStar as ReactComponent };